import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import RibbonActions from '../components/RibbonActions';
import { getActivos, createActivo, getOrdenesMantenimiento, createOrdenMant, updateOrdenMant } from '../services/api';

const ESTADOS_OM  = ['pendiente','en_progreso','completada'];
const ESTADOS_ACT = ['operativo','en_mantenimiento','fuera_servicio'];
const EC  = { pendiente:'#f59e0b', en_progreso:'#3b82f6', completada:'#10b981' };
const EA  = { operativo:'#10b981', en_mantenimiento:'#f59e0b', fuera_servicio:'#ef4444' };
const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');
const TIPO_ICON = { correctivo:'🔧', preventivo:'🛡️', predictivo:'📊' };
const TITULOS = {
  ordenes:   { h1: 'Órdenes',           sub: 'Órdenes de mantenimiento' },
  historial: { h1: 'Historial técnico', sub: 'Intervenciones completadas por activo' },
  activos:   { h1: 'Activos',           sub: 'Equipos y activos registrados' },
};

export default function Mantenimiento() {
  const [sp] = useSearchParams();
  const tab = ['ordenes', 'historial', 'activos'].includes(sp.get('tab')) ? sp.get('tab') : 'ordenes';
  const [activos,   setActivos]   = useState([]);
  const [ordenes,   setOrdenes]   = useState([]);
  const [historial, setHistorial] = useState([]);
  const [busqueda,  setBusqueda]  = useState('');
  const [filtroEstado, setFiltroEstado] = useState('');
  const [filtroActivo, setFiltroActivo] = useState('');
  const [modal,     setModal]     = useState(null); // 'activo' | 'orden' | 'cerrar'
  const [selected,  setSelected]  = useState(null);
  const [saving,    setSaving]    = useState(false);
  const [formActivo, setFormActivo] = useState({ codigo:'', nombre:'', categoria:'', marca:'', modelo:'', serial:'', ubicacion:'', estado:'operativo', fecha_adquisicion:'', valor_adquisicion:'' });
  const [formOrden,  setFormOrden]  = useState({ activo_id:'', tipo:'correctivo', descripcion:'', fecha_programada:'' });
  const [formCerrar, setFormCerrar] = useState({ estado:'completada', fecha_realizada:'', costo:'', observaciones:'' });

  const loadActivos  = () => getActivos().then(r => setActivos(r.data));
  const loadOrdenes  = () => getOrdenesMantenimiento().then(r => setOrdenes(r.data));
  const loadHistorial= () => getOrdenesMantenimiento({ estado:'completada' }).then(r => setHistorial(r.data));

  useEffect(() => { loadActivos(); loadOrdenes(); loadHistorial(); }, []);
  useEffect(() => { setBusqueda(''); setFiltroEstado(''); }, [tab]);

  const handleCreateActivo = async () => {
    if (!formActivo.codigo || !formActivo.nombre) return alert('Código y nombre son requeridos');
    setSaving(true);
    try {
      await createActivo(formActivo);
      setModal(null);
      setFormActivo({ codigo:'', nombre:'', categoria:'', marca:'', modelo:'', serial:'', ubicacion:'', estado:'operativo', fecha_adquisicion:'', valor_adquisicion:'' });
      loadActivos();
    } catch (e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  const handleCreateOrden = async () => {
    if (!formOrden.activo_id || !formOrden.descripcion) return alert('Activo y descripción son requeridos');
    setSaving(true);
    try {
      await createOrdenMant(formOrden);
      setModal(null);
      setFormOrden({ activo_id:'', tipo:'correctivo', descripcion:'', fecha_programada:'' });
      loadOrdenes();
    } catch (e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  const handleCerrar = async () => {
    setSaving(true);
    try {
      await updateOrdenMant(selected.id, formCerrar);
      setModal(null);
      setSelected(null);
      loadOrdenes();
      loadHistorial();
    } catch (e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div style={s.pageHeader}>
        <div><h1 style={s.h1}>{TITULOS[tab].h1}</h1><p style={s.sub}>{TITULOS[tab].sub}</p></div>
        <RibbonActions><div style={{ display:'flex', gap:8, alignItems:'center' }}>
          <input
            style={{ ...s.ctrl, flex:'none', width:240 }}
            placeholder={tab === 'activos' ? 'Buscar activo…' : 'Buscar orden…'}
            value={busqueda}
            onChange={e => setBusqueda(e.target.value)}
          />
          {tab === 'ordenes' && (
            <select style={{ ...s.ctrl, flex:'none', width:160 }} value={filtroEstado} onChange={e => setFiltroEstado(e.target.value)}>
              <option value="">Todos los estados</option>
              {ESTADOS_OM.map(e => <option key={e} value={e}>{e}</option>)}
            </select>
          )}
          {tab === 'activos' && (
            <select style={{ ...s.ctrl, flex:'none', width:160 }} value={filtroEstado} onChange={e => setFiltroEstado(e.target.value)}>
              <option value="">Todos los estados</option>
              {ESTADOS_ACT.map(e => <option key={e} value={e}>{e}</option>)}
            </select>
          )}
          {tab === 'historial' && (
            <select style={{ ...s.ctrl, flex:'none', width:240 }} value={filtroActivo} onChange={e => setFiltroActivo(e.target.value)}>
              <option value="">Todos los activos</option>
              {activos.map(a => <option key={a.id} value={a.id}>{a.codigo} — {a.nombre}</option>)}
            </select>
          )}
          {busqueda && (
            <button style={{ ...s.ctrl, flex:'none', width:'auto', padding:'0 12px' }} onClick={() => setBusqueda('')}>✕</button>
          )}
          <button style={s.btnSecondary} onClick={() => setModal('activo')}>+ Activo</button>
          <button style={s.btnPrimary}   onClick={() => setModal('orden')}>+ Orden</button>
        </div></RibbonActions>
      </div>

      {/* Tabla Órdenes */}
      {tab === 'ordenes' && (
        <div style={s.card}>
          <table style={s.table}>
            <thead>
              <tr>{['Número','Activo','Tipo','Descripción','Técnico','F. Programada','Estado','Acción'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {(() => {
                const q = busqueda.toLowerCase();
                const filtradas = ordenes.filter(o =>
                  (!filtroEstado || o.estado === filtroEstado) &&
                  (!q || [o.numero, o.activo_nombre, o.activo_codigo, o.descripcion, o.tecnico_nombre].some(v => v?.toLowerCase().includes(q)))
                );
                if (filtradas.length === 0) return <tr><td colSpan={8} style={{ padding:'28px', textAlign:'center', color:'#475569' }}>{busqueda ? `Sin resultados para "${busqueda}"` : 'Sin órdenes'}</td></tr>;
                return filtradas.map(o => (
                <tr key={o.id}>
                  <td style={{ ...s.td, color:'#93c5fd', fontWeight:600 }}>{o.numero}</td>
                  <td style={s.td}><p style={{ margin:0 }}>{o.activo_nombre}</p><p style={{ margin:0, color:'#64748b', fontSize:11 }}>{o.activo_codigo}</p></td>
                  <td style={s.td}><span style={{ ...s.badge, background:'#1e3a5f', color:'#93c5fd' }}>{o.tipo}</span></td>
                  <td style={{ ...s.td, maxWidth:200 }}>{o.descripcion}</td>
                  <td style={s.td}>{o.tecnico_nombre || '—'}</td>
                  <td style={s.td}>{o.fecha_programada ? new Date(o.fecha_programada).toLocaleDateString('es-CO') : '—'}</td>
                  <td style={s.td}><span style={{ ...s.badge, background:EC[o.estado]+'22', color:EC[o.estado] }}>{o.estado}</span></td>
                  <td style={s.td}>
                    {o.estado !== 'completada' && (
                      <button style={s.btnSm} onClick={() => { setSelected(o); setFormCerrar({ estado:'completada', fecha_realizada:new Date().toISOString().slice(0,10), costo:'', observaciones:'' }); setModal('cerrar'); }}>
                        Actualizar
                      </button>
                    )}
                  </td>
                </tr>
                ));
              })()}
            </tbody>
          </table>
        </div>
      )}

      {/* ── Historial técnico ── */}
      {tab === 'historial' && (
        <>
          <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16 }}>
            <span style={{ color:'#64748b', fontSize:13 }}>
              {(filtroActivo ? historial.filter(h => h.activo_id === filtroActivo) : historial).length} intervenciones
            </span>
          </div>

          {(() => {
            const q = busqueda.toLowerCase();
            const items = historial.filter(h =>
              (!filtroActivo || h.activo_id === filtroActivo) &&
              (!q || [h.numero, h.activo_nombre, h.activo_codigo, h.descripcion, h.observaciones, h.tecnico_nombre].some(v => v?.toLowerCase().includes(q)))
            );
            if (items.length === 0) return <div style={s.empty}>Sin intervenciones completadas{filtroActivo ? ' para este activo' : ''}{busqueda ? ` con "${busqueda}"` : ''}.</div>;
            return (
              <div style={{ display:'flex', flexDirection:'column', gap:0 }}>
                {items.map((h, i) => {
                  const isLast = i === items.length - 1;
                  const fecha = h.fecha_realizada
                    ? new Date(h.fecha_realizada).toLocaleDateString('es-CO', { day:'2-digit', month:'short', year:'numeric' })
                    : new Date(h.created_at).toLocaleDateString('es-CO', { day:'2-digit', month:'short', year:'numeric' });
                  return (
                    <div key={h.id} style={{ display:'flex', gap:14, position:'relative' }}>
                      {/* Línea timeline */}
                      <div style={{ display:'flex', flexDirection:'column', alignItems:'center', flexShrink:0, width:28 }}>
                        <div style={{ width:26, height:26, borderRadius:'50%', background:'#0f172a', border:`2px solid ${h.tipo==='preventivo'?'#3b82f6':'#f59e0b'}`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, zIndex:1 }}>
                          {TIPO_ICON[h.tipo] || '🔧'}
                        </div>
                        {!isLast && <div style={{ width:2, flex:1, background:'#334155', minHeight:8 }} />}
                      </div>
                      {/* Contenido */}
                      <div style={{ flex:1, background:'#1e293b', border:'1px solid #334155', borderRadius:10, padding:'12px 16px', marginBottom: isLast ? 0 : 8 }}>
                        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', flexWrap:'wrap', gap:8 }}>
                          <div>
                            <span style={{ color:'#93c5fd', fontWeight:700, fontSize:13 }}>{h.activo_nombre}</span>
                            <span style={{ color:'#475569', fontSize:12, marginLeft:8 }}>{h.activo_codigo}</span>
                            <span style={{ ...s.badge, background: h.tipo==='preventivo'?'#1e3a5f':'#78350f', color: h.tipo==='preventivo'?'#93c5fd':'#fcd34d', marginLeft:10, fontSize:11 }}>{h.tipo}</span>
                            <span style={{ color:'#64748b', fontSize:12, marginLeft:8 }}>{h.numero}</span>
                          </div>
                          <div style={{ display:'flex', gap:16, alignItems:'center' }}>
                            {h.costo > 0 && <span style={{ color:'#10b981', fontWeight:700, fontSize:13 }}>{fmt(h.costo)}</span>}
                            <span style={{ color:'#475569', fontSize:12 }}>📅 {fecha}</span>
                          </div>
                        </div>
                        <p style={{ color:'#cbd5e1', fontSize:13, margin:'8px 0 4px' }}>{h.descripcion}</p>
                        {h.observaciones && (
                          <div style={{ background:'#0f172a', borderRadius:6, padding:'8px 12px', marginTop:6, borderLeft:'3px solid #3b82f6' }}>
                            <p style={{ color:'#94a3b8', fontSize:12, margin:0 }}>
                              <strong style={{ color:'#64748b' }}>Observaciones: </strong>{h.observaciones}
                            </p>
                          </div>
                        )}
                        {h.tecnico_nombre && (
                          <p style={{ color:'#64748b', fontSize:12, margin:'6px 0 0' }}>👤 Técnico: {h.tecnico_nombre}</p>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })()}
        </>
      )}

      {/* Tabla Activos */}
      {tab === 'activos' && (
        <div style={s.card}>
          <table style={s.table}>
            <thead>
              <tr>{['Código','Nombre','Categoría','Marca / Modelo','Ubicación','Estado','Valor'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {(() => {
                const q = busqueda.toLowerCase();
                const filtrados = activos.filter(a =>
                  (!filtroEstado || a.estado === filtroEstado) &&
                  (!q || [a.codigo, a.nombre, a.categoria, a.marca, a.modelo, a.ubicacion, a.serial].some(v => v?.toLowerCase().includes(q)))
                );
                if (filtrados.length === 0) return <tr><td colSpan={7} style={{ padding:'28px', textAlign:'center', color:'#475569' }}>{busqueda ? `Sin resultados para "${busqueda}"` : 'Sin activos registrados'}</td></tr>;
                return filtrados.map(a => (
                <tr key={a.id}>
                  <td style={{ ...s.td, color:'#93c5fd', fontWeight:600 }}>{a.codigo}</td>
                  <td style={s.td}>{a.nombre}</td>
                  <td style={s.td}>{a.categoria || '—'}</td>
                  <td style={s.td}>{[a.marca, a.modelo].filter(Boolean).join(' / ') || '—'}</td>
                  <td style={s.td}>{a.ubicacion || '—'}</td>
                  <td style={s.td}><span style={{ ...s.badge, background:EA[a.estado]+'22', color:EA[a.estado] }}>{a.estado}</span></td>
                  <td style={s.td}>{a.valor_adquisicion ? '$' + Number(a.valor_adquisicion).toLocaleString('es-CO') : '—'}</td>
                </tr>
                ));
              })()}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal nuevo activo */}
      {modal === 'activo' && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>Nuevo Activo</h2><button style={s.closeBtn} onClick={() => setModal(null)}>✕</button></div>
            <div style={s.modalBody}>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Código *</label><input style={s.input} value={formActivo.codigo} onChange={e => setFormActivo({...formActivo, codigo:e.target.value})} /></div>
                <div style={s.field}><label style={s.label}>Nombre *</label><input style={s.input} value={formActivo.nombre} onChange={e => setFormActivo({...formActivo, nombre:e.target.value})} /></div>
                <div style={s.field}><label style={s.label}>Categoría</label><input style={s.input} value={formActivo.categoria} onChange={e => setFormActivo({...formActivo, categoria:e.target.value})} /></div>
                <div style={s.field}><label style={s.label}>Estado</label>
                  <select style={s.input} value={formActivo.estado} onChange={e => setFormActivo({...formActivo, estado:e.target.value})}>
                    {ESTADOS_ACT.map(e => <option key={e} value={e}>{e}</option>)}
                  </select>
                </div>
                <div style={s.field}><label style={s.label}>Marca</label><input style={s.input} value={formActivo.marca} onChange={e => setFormActivo({...formActivo, marca:e.target.value})} /></div>
                <div style={s.field}><label style={s.label}>Modelo</label><input style={s.input} value={formActivo.modelo} onChange={e => setFormActivo({...formActivo, modelo:e.target.value})} /></div>
                <div style={s.field}><label style={s.label}>Serial</label><input style={s.input} value={formActivo.serial} onChange={e => setFormActivo({...formActivo, serial:e.target.value})} /></div>
                <div style={s.field}><label style={s.label}>Ubicación</label><input style={s.input} value={formActivo.ubicacion} onChange={e => setFormActivo({...formActivo, ubicacion:e.target.value})} /></div>
                <div style={s.field}><label style={s.label}>Fecha adquisición</label><input style={s.input} type="date" value={formActivo.fecha_adquisicion} onChange={e => setFormActivo({...formActivo, fecha_adquisicion:e.target.value})} /></div>
                <div style={s.field}><label style={s.label}>Valor adquisición</label><input style={s.input} type="number" value={formActivo.valor_adquisicion} onChange={e => setFormActivo({...formActivo, valor_adquisicion:e.target.value})} /></div>
              </div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(null)}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} onClick={handleCreateActivo} disabled={saving}>{saving ? 'Guardando...' : 'Crear activo'}</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal nueva orden */}
      {modal === 'orden' && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>Nueva Orden de Mantenimiento</h2><button style={s.closeBtn} onClick={() => setModal(null)}>✕</button></div>
            <div style={s.modalBody}>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Activo *</label>
                  <select style={s.input} value={formOrden.activo_id} onChange={e => setFormOrden({...formOrden, activo_id:e.target.value})}>
                    <option value="">Seleccionar activo</option>
                    {activos.map(a => <option key={a.id} value={a.id}>{a.codigo} — {a.nombre}</option>)}
                  </select>
                </div>
                <div style={s.field}><label style={s.label}>Tipo</label>
                  <select style={s.input} value={formOrden.tipo} onChange={e => setFormOrden({...formOrden, tipo:e.target.value})}>
                    <option value="correctivo">Correctivo</option>
                    <option value="preventivo">Preventivo</option>
                  </select>
                </div>
              </div>
              <div style={s.field}><label style={s.label}>Descripción *</label>
                <textarea style={{ ...s.input, minHeight:80, resize:'vertical' }} value={formOrden.descripcion} onChange={e => setFormOrden({...formOrden, descripcion:e.target.value})} />
              </div>
              <div style={s.field}><label style={s.label}>Fecha programada</label>
                <input style={s.input} type="date" value={formOrden.fecha_programada} onChange={e => setFormOrden({...formOrden, fecha_programada:e.target.value})} />
              </div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(null)}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} onClick={handleCreateOrden} disabled={saving}>{saving ? 'Guardando...' : 'Crear orden'}</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal actualizar orden */}
      {modal === 'cerrar' && selected && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>Actualizar {selected.numero}</h2><button style={s.closeBtn} onClick={() => setModal(null)}>✕</button></div>
            <div style={s.modalBody}>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Estado</label>
                  <select style={s.input} value={formCerrar.estado} onChange={e => setFormCerrar({...formCerrar, estado:e.target.value})}>
                    {ESTADOS_OM.map(e => <option key={e} value={e}>{e}</option>)}
                  </select>
                </div>
                <div style={s.field}><label style={s.label}>Fecha realizada</label>
                  <input style={s.input} type="date" value={formCerrar.fecha_realizada} onChange={e => setFormCerrar({...formCerrar, fecha_realizada:e.target.value})} />
                </div>
                <div style={s.field}><label style={s.label}>Costo ($)</label>
                  <input style={s.input} type="number" value={formCerrar.costo} onChange={e => setFormCerrar({...formCerrar, costo:e.target.value})} />
                </div>
              </div>
              <div style={s.field}><label style={s.label}>Observaciones</label>
                <textarea style={{ ...s.input, minHeight:80, resize:'vertical' }} value={formCerrar.observaciones} onChange={e => setFormCerrar({...formCerrar, observaciones:e.target.value})} />
              </div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(null)}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} onClick={handleCerrar} disabled={saving}>{saving ? 'Guardando...' : 'Actualizar'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  pageHeader:  { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:6 },
  h1:          { color:'#f1f5f9', fontSize:24, fontWeight:700, margin:'0 0 4px' },
  sub:         { color:'#64748b', fontSize:14, margin:0 },
  btnPrimary:  { background:'#1d4ed8', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, fontWeight:600, cursor:'pointer' },
  btnSecondary:{ background:'#334155', color:'#cbd5e1', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, cursor:'pointer' },
  btnSm:       { background:'#1e40af', color:'#93c5fd', border:'none', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer' },
  tabs:        { display:'flex', gap:4, marginBottom:20, borderBottom:'1px solid #334155', paddingBottom:0 },
  tab:         { background:'transparent', border:'none', color:'#64748b', padding:'10px 18px', fontSize:13, cursor:'pointer', borderBottom:'2px solid transparent', marginBottom:-1 },
  tabActive:   { color:'#93c5fd', borderBottomColor:'#3b82f6' },
  card:        { background:'#1e293b', borderRadius:12, overflow:'hidden' },
  table:       { width:'100%', borderCollapse:'collapse' },
  th:          { padding:'12px 16px', color:'#64748b', fontSize:12, textAlign:'left', borderBottom:'1px solid #334155', background:'#162032' },
  td:          { padding:'12px 16px', color:'#cbd5e1', fontSize:13, borderBottom:'1px solid #1a2332', verticalAlign:'top' },
  empty:       { padding:'32px', textAlign:'center', color:'#475569', background:'#1e293b', borderRadius:10, border:'1px solid #334155' },
  input:       { width:'100%', height:34, padding:'0 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none' },
  ctrl:        { height:38, padding:'0 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none', cursor:'pointer', flex:1, maxWidth:340 },
  badge:       { padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600 },
  overlay:     { position:'fixed', inset:0, background:'rgba(0,0,0,.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 },
  modal:       { background:'#1e293b', borderRadius:16, width:'90%', maxWidth:640, maxHeight:'90vh', display:'flex', flexDirection:'column', border:'1px solid #334155' },
  modalHeader: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'13px 20px', borderBottom:'1px solid #334155' },
  modalTitle:  { color:'#f1f5f9', fontSize:16, fontWeight:700, margin:0 },
  closeBtn:    { background:'transparent', border:'none', color:'#64748b', fontSize:18, cursor:'pointer' },
  modalBody:   { padding:'14px 20px', overflowY:'auto', flex:1 },
  modalFooter: { display:'flex', justifyContent:'flex-end', gap:10, padding:'12px 20px', borderTop:'1px solid #334155' },
  row2:        { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 },
  field:       { marginBottom:10 },
  label:       { display:'block', color:'#94a3b8', fontSize:12, marginBottom:4, fontWeight:500 },
  input:       { width:'100%', height:34, padding:'0 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none' },
};
